<template>
  <Head title="Audience Template List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-2 pt-4">
        <transformation-segments-manager 
          :segments="segments"
          :transformations="transformations"
        ></transformation-segments-manager>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  segments: Array,
  transformations: Array
});
</script>

